import { registerThemingParticipant } from 'monaco-editor/esm/vs/platform/theme/common/themeService.js';
import { TITLE_BAR_ACTIVE_BACKGROUND, WORKBENCH_BACKGROUND } from '../common/theme.js';
import { isWeb, isIOS, isWindows, isMacintosh } from 'monaco-editor/esm/vs/base/common/platform.js';
import { createMetaElement } from 'monaco-editor/esm/vs/base/browser/dom.js';
import { isSafari, isStandalone } from 'monaco-editor/esm/vs/base/browser/browser.js';
import { selectionBackground } from 'monaco-editor/esm/vs/platform/theme/common/colorRegistry.js';
registerThemingParticipant((theme, collector) => {
    const workbenchBackground = WORKBENCH_BACKGROUND(theme);
    collector.addRule(`.monaco-workbench { background-color: ${workbenchBackground}; }`);
    const windowSelectionBackground = theme.getColor(selectionBackground);
    if (windowSelectionBackground) {
        collector.addRule(`.monaco-workbench ::selection { background-color: ${windowSelectionBackground}; }`);
    }
    if (isWeb) {
        const titleBackground = theme.getColor(TITLE_BAR_ACTIVE_BACKGROUND);
        if (titleBackground) {
            const metaElementId = 'monaco-workbench-meta-theme-color';
            let metaElement = document.getElementById(metaElementId);
            if (!metaElement) {
                metaElement = createMetaElement();
                metaElement.name = 'theme-color';
                metaElement.id = metaElementId;
            }
            metaElement.content = ( titleBackground.toString());
        }
    }
    if (isSafari) {
        collector.addRule(`
			body.web {
				touch-action: none;
			}
			.monaco-workbench .monaco-editor .view-lines {
				user-select: text;
				-webkit-user-select: text;
			}
		`);
    }
    if (isIOS && isStandalone()) {
        collector.addRule(`body { background-color: ${workbenchBackground}; }`);
    }
});
const DEFAULT_FONT_FAMILY = isWindows ? '"Segoe WPC", "Segoe UI", sans-serif' : isMacintosh ? '-apple-system, BlinkMacSystemFont, sans-serif' : 'system-ui, "Ubuntu", "Droid Sans", sans-serif';
export { DEFAULT_FONT_FAMILY };
